import { Asset } from '../types/comparables.interfaces';
import { ErrorLogItem } from '../types/errors.interface';

export function getRequestErrorLog(error: any, endpoint: string, params: any) {
  const errorLog: ErrorLogItem = {
    errortype: 'request',
    errorname: error.name || 'RequestError',
    message: error.message || 'An error occurred during the request',
    endpoint: endpoint,
    params: params,
  };
  return errorLog;
}

type Point = [number, number]; // [longitude, latitude]

interface BoundingBox {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

// Function to calculate the bounding box
export function calculateBoundingBox(points: Point[]): BoundingBox {
  let minLat = Infinity,
    maxLat = -Infinity;
  let minLng = Infinity,
    maxLng = -Infinity;

  points.forEach((point) => {
    const [lng, lat] = point;
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
  });

  return { minLat, maxLat, minLng, maxLng };
}

export function calculateZoomLevel(maxDistance: number) {
  const EARTH_CIRCUMFERENCE = 12800000;
  const zoom = Math.log2(EARTH_CIRCUMFERENCE / maxDistance);

  return Math.max(0, Math.min(zoom, 15.4));
}
